// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.MappingErrorTree.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIO

import React, { Component } from 'react';
import TreeView from 'share/components/controls/Izenda.TreeView';
import PropTypes from 'prop-types';
import { escape, uniqueId, get, getOr } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';

@connect()
export default class MappingErrorTree extends Component {
  static propTypes = {
    errorMessages: PropTypes.array
  };

  /**
   * @param {Object} node
   * @returns {Array}
   */
  getChildNodes = (node: any): Array<any> => {
    if (node.report) return node.errors;
    if (node.dashboard) return node.dashboard.reports;
    return [];
  };

  /**
   * Render error messages
   * @param {Object} node
   */
  renderErrorMessage(node: any): any {    
    let errorMsg = escape(node).replace(new RegExp('\\[', 'gm'), '<strong>');
    errorMsg = errorMsg.replace(new RegExp('\\]', 'gm'), '</strong>');

    return (
      <label className="u_marginLeftInnerSpace" dangerouslySetInnerHTML={{ __html: errorMsg }}></label>
    );
  }

  /**
   * Render error messages
   * @param {Object} node
   * @param {Object} toggleIcon
   */
  renderErrorLocation(node: any, toggleIcon: any) {
    const { localization } = this.props;
    let textError = '';
    let objectName = '';
    let fileName = '';

    if (node.report) {
      textError = `${localization.getText('CONTEXT_MENU_LABEL_REPORT')}: `;
      objectName = node.report;
      fileName = getOr('', 'fileName', node);
    } else {
      textError = `${localization.getText('CONTEXT_MENU_LABEL_DASHBOARD')}: `;
      objectName = get('dashboard.dashboard', node);
      fileName = getOr('', 'dashboard.fileName', node);
    }

    const location = fileName ? localization.getText('IMPORT_MAPPING_ERROR_OBJECT_LOCATION') : '';

    return (
      <div>
        {toggleIcon}
        <label className="u_marginLeftInnerSpace">{textError}
          <strong>{objectName}</strong> {location} <strong>{fileName}</strong>
        </label>
      </div>
    );
  }

  renderNode = (node: any, toggleIcon: any) => {
    if (!node.report && !node.dashboard) {
      return this.renderErrorMessage(node);
    }
    return this.renderErrorLocation(node, toggleIcon);
  };

  /**
   * Set node always expands
   * @returns {boolean}
   */
  nodeExpand = (): boolean => {
    return true;
  };

  /**
   * Create uniqueId for node
   * @returns {string}
   */
  getKey = (): string => {
    return uniqueId('MappingErrorTree_');
  };

  render() {
    const { errorMessages } = this.props;

    return (
      <div className="u_fullSize u_borderAll izenda-MappingError-tree">
        <TreeView
          collapsed={false}
          nodes={errorMessages}
          getKey={this.getKey}
          renderNode={this.renderNode}
          getChildNodes={this.getChildNodes}
          nodeExpand={this.nodeExpand}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.MappingErrorTree.js